import { createContext, useReducer, useEffect } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import { environment } from "../environments/environment";

export const AuthContext = createContext();

export const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return { user: action.payload };
    case "LOGOUT":
      return { user: null };
    case "UPDATE_USER":
      return { user: state.user ? { ...state.user, ...action.payload } : null };
    default:
      return state;
  }
};

// eslint-disable-next-line react/prop-types
export const AuthContextProvider = ({ children }) => {
  let userCookie = Cookies.get("user");
  try {
    if (userCookie) userCookie = JSON.parse(userCookie);
  } catch {
    userCookie = null;
  }

  const [state, dispatch] = useReducer(authReducer, {
    user: userCookie,
  });

  useEffect(() => {
    if (userCookie) dispatch({ type: "LOGIN", payload: userCookie });
  }, []);

  // Sync onboardingDone from backend when cookie has no onboardingDone (e.g. existing sessions)
  useEffect(() => {
    const u = state.user;
    if (!u?.accessToken || u.onboardingDone !== undefined) return;
    axios
      .get(`${environment.BACKEND}/user`, {
        headers: { Authorization: `Bearer ${u.accessToken}` },
      })
      .then((res) => {
        const onboardingDone = res?.data?.data?.onboardingDone;
        if (onboardingDone !== undefined) {
          const updated = { ...u, onboardingDone };
          Cookies.set("user", JSON.stringify(updated), { expires: 365 });
          dispatch({ type: "UPDATE_USER", payload: { onboardingDone } });
        }
      })
      .catch(() => {});
  }, [state.user?.accessToken, state.user?.onboardingDone]);

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
